import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { HStack } from "@whoosh/design-system/src/components/primitive";

import { BundledRateAndTransportSelect } from "./BundledRateAndTransportSelect/BundledRateAndTransportSelect";
import { CourseLayoutControl } from "./CourseLayoutControl/CourseLayoutControl";
import { GolfPlayerRateControl } from "./PlayerRateControl/GolfPlayerRateControl";
import { TransportationTypeControl } from "./TransportationTypeControl/TransportationTypeControl";
import { GolfRoundControls_Booking$key } from "./__generated__/GolfRoundControls_Booking.graphql";

type Props = {
  bookingRef: GolfRoundControls_Booking$key;
  roundId: string;
};
export const GolfRoundControls = ({ bookingRef, roundId }: Props) => {
  const booking = useFragment(GolfRoundControlsFragmentString, bookingRef);
  const isPrivateClub =
    booking.startSlot?.agenda.facility.club?.supportsPrivate ?? false;
  const shouldShowAsBundled =
    !isPrivateClub &&
    booking.startSlot?.agenda.facility.publicBookingPermissionSet
      ?.rateDisplay === "BUNDLED";

  return (
    <HStack gap={1}>
      <CourseLayoutControl bookingRef={booking} roundId={roundId} />
      {shouldShowAsBundled ? (
        <BundledRateAndTransportSelect bookingRef={booking} roundId={roundId} />
      ) : (
        <>
          <TransportationTypeControl
            roundId={roundId}
            shouldFillWidth={isPrivateClub}
          />
          {!isPrivateClub ? (
            <GolfPlayerRateControl bookingRef={booking} roundId={roundId} />
          ) : null}
        </>
      )}
    </HStack>
  );
};
const GolfRoundControlsFragmentString = graphql`
  fragment GolfRoundControls_Booking on Booking {
    ...CourseLayoutControl_Booking
    ...GolfPlayerRateControl_Booking
    ...BundledRateAndTransportSelect_Booking
    startSlot {
      agenda {
        facility {
          club {
            supportsPrivate
          }
          publicBookingPermissionSet {
            rateDisplay
          }
        }
      }
    }
  }
`;
